<template>
  <div class="app-wrapper">
    <LayoutComponent />
  </div>
</template>

<script>
import LayoutComponent from './components/LayoutComponent.vue';
export default {
  name: 'App',
  components: {
    LayoutComponent
  }
};
</script>
<style>
.app-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>